import React, { ReactNode } from 'react';
import "./SectionContainer.css"

type SectionContainerProps = {
    children: ReactNode;
    margin?: string;
    className?: string;
    noMargin?: boolean; // Adiciona a nova propriedade noMargin
    disabled? : boolean;
}

export function SectionContainer({children, margin = '1rem', className, noMargin = false, disabled} : SectionContainerProps){

    return (
        <div 
            className={`section-container ${className}`} 
            style={{ 
                marginLeft: noMargin ? '0' : margin,
                opacity: disabled ? 0.5 : 1
            }} // Se noMargin for true, a margem é removida
        >
            {children}
        </div>
    )
}
    